var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoublebed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Double bed",
    clipPath: "url(#clip0_2_636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5489 13.5543V3.53115C22.5489 3.21695 22.3405 2.9409 22.0382 2.85488C15.4456 0.978711 8.47626 0.978711 1.88358 2.85488C1.58137 2.9409 1.37287 3.21695 1.37287 3.53115V13.651C0.513938 14.7316 0 16.0982 0 17.5827V21.8493C0 22.2376 0.314812 22.5524 0.703125 22.5524C1.09144 22.5524 1.40625 22.2376 1.40625 21.8493V21.099H22.5938V21.8493C22.5938 22.2376 22.9086 22.5524 23.2969 22.5524C23.6852 22.5524 24 22.2376 24 21.8493V17.5827C24 16.0536 23.4549 14.6495 22.5489 13.5543ZM6.32925 12.6596H17.6707C20.1425 12.6596 22.1944 14.4909 22.5417 16.8679H1.45833C1.80562 14.4909 3.85748 12.6596 6.32925 12.6596ZM9.89034 11.2533C6.33581 11.2637 6.23977 11.2284 5.67042 11.2875V8.67446C5.67042 8.54513 5.77566 8.4399 5.90498 8.4399H9.65578C9.78516 8.4399 9.89039 8.54513 9.89039 8.67446L9.89034 11.2533ZM18.3249 11.287C17.759 11.2286 17.637 11.2635 14.105 11.2533V8.67446C14.105 8.54513 14.2103 8.4399 14.3396 8.4399H18.0904C18.2197 8.4399 18.3249 8.54513 18.3249 8.67446V11.287H18.3249ZM21.1427 4.06618V12.2934C20.7066 12.0061 20.2331 11.7712 19.7311 11.5979V8.67446C19.7311 7.76973 18.9951 7.03365 18.0903 7.03365H14.3395C13.4348 7.03365 12.6987 7.76973 12.6987 8.67446V11.2533H11.2966V8.67446C11.2966 7.76973 10.5605 7.03365 9.65573 7.03365H5.90494C5.0002 7.03365 4.26412 7.76973 4.26412 8.67446V11.5996C3.73383 11.7832 3.23527 12.0352 2.77912 12.3453V4.06618C8.79806 2.44988 15.1237 2.44988 21.1427 4.06618ZM1.40625 19.6927V18.2741H22.5938V19.6927H1.40625Z",
    fill: "#806A50",
    stroke: "#806A50",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 69",
    x: 5,
    y: 8,
    width: 5,
    height: 4,
    fill: "#806A50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 70",
    x: 14,
    y: 8,
    width: 5,
    height: 4,
    fill: "#806A50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublebed);
export default __webpack_public_path__ + "static/media/Doublebed.e8507484cfde30efd830a850d37bdf82.svg";
export { ForwardRef as ReactComponent };